import { render, staticRenderFns } from "./MilestoneTaskBoardHistoryView.vue?vue&type=template&id=67021867&"
import script from "./MilestoneTaskBoardHistoryView.vue?vue&type=script&lang=js&"
export * from "./MilestoneTaskBoardHistoryView.vue?vue&type=script&lang=js&"
import style0 from "./MilestoneTaskBoardHistoryView.vue?vue&type=style&index=0&id=67021867&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports